:host {
  display: block;

  @apply block;
}
